import React from "react";
import { Link } from "react-router-dom";
import SideBarNav from "./SideBarNav";
import { getAutoRenewalDetail } from "../../modules/actions/autoRenewalActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
class AutoRenewalDetail extends React.Component {
  componentDidMount() {
    const profileId = this.props.match.params.id;
    console.log(this.props.match.params.id);
    this.props.getAutoRenewalDetail(profileId);
  }
  render() {
    console.log("autorenewaldetail", this.props);
    const { autoRenewalDetail } = this.props;
    console.log("autoRenewalDetail", autoRenewalDetail);
    return (
        <section className="BodyContainer">
          <div className="container">
            <div className="row">
              <SideBarNav />

              <div className="col-lg-8 order-history">
                <div className="mt-0">
                  <h4 className="features_title">Auto Renewal History</h4>

                  <div style={{ clear: "both", height: "15px" }} />

                  <div className="table-responsive orders-list">
                    <table className="table">
                      <thead>
                      <tr>
                        <th>ORDER #</th>
                        <th>date</th>
                        <th>order total</th>
                        <th>next renewal date</th>
                        <th>Renewal Status</th>
                        <th />
                      </tr>
                      </thead>
                      <tbody>
                      {autoRenewalDetail.map(function(autoRenewal, index) {
                        return (
                            <tr key={index}>
                              <td>
                                <Link to={`/dashboard/order/${autoRenewal.orderId}`}>
                                  {autoRenewal.orderId}
                                </Link>
                              </td>
                              <td>
                                {moment(autoRenewal.orderDate).format("MM/DD/YYYY")}
                              </td>
                              <td>${autoRenewal.total}</td>
                              <td>
                                {moment(autoRenewal.startDate).format("MM/DD/YYYY")}
                              </td>
                              <td>Active</td>
                              <td>
                                <Link to={`/dashboard/autorenewal/${autoRenewal.profileId}`}>
                                  View history
                                </Link>
                              </td>
                            </tr>
                        );
                      })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }
}
AutoRenewalDetail.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    autoRenewalDetail: state.autoRenewal.autoRenewalDetail
  };
}

export default connect(
    mapStateToProps,
    { getAutoRenewalDetail, addFlashMessage }
)(AutoRenewalDetail);



// WEBPACK FOOTER //
// ./src/pages/dashboard/AutoRenewalDetail.js